
<section id="page" *ngIf="!isNoAccessRoute() && appService?.loggedInUser?.name">
  <app-header style="z-index: 2147483647 !important;" class="zs-border-bottom zs-bg-standard"></app-header>
  <app-session-info-bar></app-session-info-bar>
  <app-side-nav class="zs-layout-full-sidenav"></app-side-nav>
  <main class="main-page">

    <app-alert-box *ngIf="appService.showAlert.show"></app-alert-box>

    <div class="main-page__header zs-border-bottom zs-bg-standard">
      <div class="main-page__header__title"><h4>{{pageTitle| uppercase}}</h4></div>
      <div class="main-page__header__refreshDate" style=" display: flex; align-items: center; gap: 12px;">
        <span *ngIf="pageTitle === 'global inputs' && appService.resources.GiNotes.Visible == 'Y'" class="zs-icon zs-size-xl zs-icon-data-list notes-icon" title="Notes" style=" margin-top: 6px; margin-left: -8px; margin-bottom: 4px; cursor: pointer;"
  (click)="openNotes()">
        </span>
        <span class="zs-icon zs-size-l zs-icon-info-fill"></span>
        <span class="zs-size-m">Current System Data: Through {{appService.lastDataRefreshDate | date: 'MMMM yyyy'}}</span>
      </div>
    </div>
    <app-help-tab *ngIf="appService.openFAQSectionFlag && appService.loggedInUser.team != ''"></app-help-tab>
    <div id="mainPageContent" class="main-page__content" [appLoading]="isLoading">
      <router-outlet (activate) = "updatePageTitle($event);"></router-outlet>
    </div>
  </main>
  <app-footer *ngIf="(pageTitle| lowercase) == 'projects & scenarios'"></app-footer>
</section>
<!-- Render only the router outlet for the No Access route -->
<section *ngIf="isNoAccessRoute()">
<router-outlet></router-outlet>
</section>
<app-bot *ngIf="appService.resources.Chatbot.Visible == 'Y'"></app-bot>
